<div class="mb-3">
  <label *ngIf="label" class="form-label">
    {{ label }}
    <span *ngIf="required" class="text-danger ms-1">*</span>
  </label>

  <!-- Custom select wrapper -->
  <div
    #selectWrapper
    class="is-select"
    [class.is-select--open]="isOpen"
    [class.is-select--disabled]="isDisabled"
    [class.is-select--error]="hasError"
    [class.is-select--focused]="isOpen"
  >
    <!-- Trigger -->
    <div
      class="is-select__trigger"
      role="combobox"
      tabindex="0"
      [attr.aria-expanded]="isOpen"
      [attr.aria-label]="label || placeholder"
      (click)="toggle()"
      (keydown)="onKeydown($event)"
    >
      <span class="is-select__value" [class.is-select__placeholder]="!selectedLabel">
        {{ selectedLabel || placeholder }}
      </span>
      <div class="is-select__icons">
        <button
          *ngIf="value && !isDisabled"
          type="button"
          class="is-select__clear"
          (click)="clear($event)"
          [attr.aria-label]="'IS_LIB.CLEAR' | translate"
        >
          <i class="bx bx-x"></i>
        </button>
        <i class="bx bx-chevron-down is-select__arrow"></i>
      </div>
    </div>

    <!-- Dropdown -->
    <div *ngIf="isOpen" class="is-select__dropdown">
      <!-- Search (when > 6 options) -->
      <div *ngIf="options.length > 6" class="is-select__search">
        <i class="bx bx-search is-select__search-icon"></i>
        <input
          #searchInput
          type="text"
          class="is-select__search-input"
          [placeholder]="'IS_LIB.SEARCH_PLACEHOLDER' | translate"
          [(ngModel)]="searchTerm"
          (input)="filterOptions()"
          (keydown)="onSearchKeydown($event)"
        >
      </div>

      <!-- Options list -->
      <ul class="is-select__options" role="listbox">
        <li
          *ngFor="let opt of filteredOptions; let i = index"
          class="is-select__option"
          [class.is-select__option--selected]="opt.value === value"
          [class.is-select__option--highlighted]="i === highlightedIndex"
          [class.is-select__option--disabled]="opt.disabled"
          role="option"
          [attr.aria-selected]="opt.value === value"
          (click)="selectOption(opt)"
          (mouseenter)="highlightedIndex = i"
        >
          <span>{{ opt.label }}</span>
          <i *ngIf="opt.value === value" class="bx bx-check is-select__check"></i>
        </li>

        <!-- Empty state -->
        <li *ngIf="filteredOptions.length === 0" class="is-select__empty">
          {{ 'IS_LIB.NO_RECORDS' | translate }}
        </li>
      </ul>
    </div>
  </div>

  <small *ngIf="helpText && !hasError" class="form-text text-muted">{{ helpText }}</small>
  <is-form-error *ngIf="control" [control]="control"></is-form-error>
</div>
